import React from 'react';
import { DnsRecordCodeCell } from '../DnsRecordCodeCell/DnsRecordCodeCell';
import * as S from './DnsRecordValueCell.styled';
export const DnsRecordValueCell = ({ record }) => (React.createElement(React.Fragment, null,
    React.createElement(DnsRecordCodeCell, { value: record.value || '', recordAlias: record.alias }),
    record.priority && React.createElement(S.Priority, null,
        "(Priority: ",
        record.priority,
        ")")));
